require('./brokerCashChargeView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const { LabelDate } = require('commonsComponents/labelDate');
const BrokerCashChargeWizard = require('components/broker/brokerCashCharge/brokerCashChargeWizard');
const BrokerCashChargeSuccess = require('components/broker/brokerCashCharge/brokerCashChargeSuccess/brokerCashChargeSuccess');

// @helpers
const { formatText, FormattedText, getFinalTitle, getLanguage } = require('core/i18n').i18n;
const { getDocumentURL } = require('utilities/stringHelper');

// @actions
const BrokerCashChargeActions = require('actions/brokerCashCharge');

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    CHARGE_ACCOUNT_PREFIX
} = require('constants/index');
const CLASS_NAME = 'broker-cash-charge-view';
const HELP_LINK = ''; // @hardcoded
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const language = getLanguage();

class BrokerCashChargeView extends React.Component {
    buildSideColumn() {
        const { immBrokerCashCharge, immCorporatesOperations } = this.props;
        const firstStepTitlesAmount = immBrokerCashCharge.getIn(['steps', FIRST_STEP, 'titlesAmount']);
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const contractProductNumber = selectedContract.getIn(['cuenta', 'digitodecontrol']) + selectedContract.getIn(['cuenta', 'fullNumber']);
        const fullContractNumber = CHARGE_ACCOUNT_PREFIX + contractProductNumber;

        let dateField;
        let titlesAmountInformation;

        // Only display end date in second step
        if (immBrokerCashCharge.get('visibleStep') == SECOND_STEP + 1) {
            dateField = (
                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="cashCharge-date"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        <LabelDate
                            date={immBrokerCashCharge.getIn(['operation', 'endDate'])}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </div>
                </div>
            );
        }

        if (firstStepTitlesAmount) {
            titlesAmountInformation = (
                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="cashCharge-titlesAmount"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {firstStepTitlesAmount}
                    </div>
                </div>
            );
        }

        return (
            <OKSectionBox>
                <h4><FormattedText value="cashCharge-value" /></h4>

                <div className={`${CLASS_NAME}__sidecolumn-header`}>
                    <h3 className={`${CLASS_NAME}__sidecolumn-header-title`}>{immBrokerCashCharge.getIn(['operation', 'descriptionValue'])}</h3>
                    <h5 className={`${CLASS_NAME}__sidecolumn-header-subtitle ${CLASS_NAME}__lighter-fg`}>
                        {immBrokerCashCharge.getIn(['operation', 'stockExchange'])}
                    </h5>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="cashCharge-contract"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {immBrokerCashCharge.get('walletAccountType')}
                    </div>
                    <div className={`${CLASS_NAME}__lighter-fg`}>
                        <FormattedText
                            value="cashCharge-contractNumber"
                            injectedStrings={[fullContractNumber]}
                        />
                    </div>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="cashCharge-owner"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {immBrokerCashCharge.get('owner')}
                    </div>
                </div>

                {titlesAmountInformation}

                {dateField}
            </OKSectionBox>
        );
    }

    buildSuccess() {
        const { immBrokerCashCharge } = this.props;

        return (
            <BrokerCashChargeSuccess
                immBrokerCashCharge={immBrokerCashCharge}
            />
        );
    }

    buildWizard() {
        const {
            immBrokerCashCharge,
            onChangeTitlesAmount,
            onChangeAcceptedInstructions,
            onValidateStep,
            onSetVisibleStep,
            onWillCancel,
            onFinish
        } = this.props;

        return (
            <BrokerCashChargeWizard
                immBrokerCashCharge={immBrokerCashCharge}
                onChangeTitlesAmount={onChangeTitlesAmount}
                onChangeAcceptedInstructions={onChangeAcceptedInstructions}
                onValidateStep={onValidateStep}
                onSetVisibleStep={onSetVisibleStep}
                onFinish={onFinish}
                onWillCancel={onWillCancel}
            />
        );
    }

    render() {
        const { immBrokerCashCharge, immVariables } = this.props;
        const breadcrumb = [
            {
                text: formatText('cashCharge-investments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('cashCharge-corporateOperations'),
                url: '/myprofile/broker/corporatesOperations'
            },
            {
                text: formatText('cashCharge-capitalIncrease'),
                url: ''
            }
        ];
        let commissionsButton;
        let helpButton;
        let content;

        if (immBrokerCashCharge.get('finished')) {
            content = this.buildSuccess();
        } else {
            const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
            commissionsButton = (
                <OKButton
                    inverse={true}
                    modifier="ghost"
                    onClick={() => window.open(fees_url)}
                >
                    <FormattedText value="cashCharge-commissions" />
                </OKButton>
            );

            helpButton = (
                <OKButton
                    inverse={true}
                    modifier="ghost"
                    onClick={() => window.open(HELP_LINK)}
                >
                    <FormattedText value="cashCharge-help" />
                </OKButton>
            );

            content = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {this.buildWizard()}
                    </div>

                    <div className="col-xs-4">
                        {this.buildSideColumn()}
                    </div>
                </div>
            );
        }

        return (
            <section className={CLASS_NAME}>
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        subtitleLeft={formatText('cashCharge-subtitle')}
                        finalTitle={getFinalTitle('cashCharge-title')}
                    >
                        {commissionsButton}
                        {helpButton}
                    </OKHeaderSubPage>
                </OKCover>
                <section className={`${CLASS_NAME}__body`}>
                    {content}
                </section>
            </section>
        );
    }
}

BrokerCashChargeView.propTypes = {
    immBrokerCashCharge: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    onChangeAcceptedInstructions: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onWillCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerCashChargeView;
module.exports.BrokerCashChargeView = connect(
    (state) => ({
        immBrokerCashCharge: state.brokerCashCharge,
        immCorporatesOperations: state.brokerCorporatesOperations,
        immVariables: state.globalVariables
    }),
    {
        onChangeTitlesAmount: BrokerCashChargeActions.changeTitlesAmount,
        onChangeAcceptedInstructions: BrokerCashChargeActions.changeAcceptInstructions,
        onValidateStep: BrokerCashChargeActions.validateStep,
        onSetVisibleStep: BrokerCashChargeActions.setVisibleStep,
        onWillCancel: BrokerCashChargeActions.setWillCancel,
        onFinish: BrokerCashChargeActions.finish
    }
)(BrokerCashChargeView);
